var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAutoApprove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#41505F",
  fillRule: "nonzero",
  d: "M16.632 10.398h-3.649a.584.584 0 0 1-.582-.583V4.582c0-.567-.725-.797-1.056-.337L6.11 12.68c-.274.384 0 .92.473.92h3.638c.322 0 .583.261.583.583v5.236c0 .567.725.797 1.056.337l5.248-8.437a.584.584 0 0 0-.475-.92"
})));
export { SvgAutoApprove as ReactComponent };
export default __webpack_public_path__ + "static/media/autoApprove.a1636f2d.svg";